import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ElementRef, Injectable } from '@angular/core';

/**
 * Tooltip overlay service
 */
@Injectable()
export class TooltipService {
  /** Dependencies. */
  constructor(private overlay: Overlay) {}

  /**
   * Returns overlay for tooltip.
   * @param elementRef Origin element to attach Tooltip to.
   */
  public createOverlay(elementRef: ElementRef<HTMLElement>): OverlayRef {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(elementRef)
      .withFlexibleDimensions(false)
      .withViewportMargin(10)
      .withPush(true);

    return this.overlay.create({
      positionStrategy,
    });
  }
}
